import { ROUTES } from '@aibees/elephant/router';
import { Icon, LinkButton, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Button, Skeleton, Stack } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { DetailHeaderProps as Props } from './types';

export const DetailHeader = memo(
  ({ className, links, avatarSrc, name, id, icon, isPeople }: Props) => {
    if (!name) {
      return <Skeleton animation="wave" variant="rounded" sx={SX.skeleton} />;
    }

    const companyPageLink = ROUTES.company.replace(':id', id ?? '#');
    const peoplePageLink = ROUTES.people.replace(':id', id ?? '#');

    return (
      <Styled.Wrapper
        className={classnames('DetailHeader', className)}
        sx={SX.root}
      >
        <Stack direction="row" gap={1} overflow="hidden">
          <Avatar variant="rounded" src={avatarSrc} size={40} color="white">
            <Icon size={20} name={icon || 'business'} color="grey.400" />
          </Avatar>

          <Stack overflow="hidden">
            <TextEllipsis
              value={name}
              variant="body2"
              fontWeight="bold"
              color="grey.700"
            />

            <Stack direction="row" gap={0.5}>
              {links.map((i) => (
                <LinkButton
                  key={i.href}
                  href={i.href ?? undefined}
                  sx={SX.linkOut}
                  disabled={!i.href}
                >
                  <Icon
                    name={i.icon}
                    size={16}
                    color={i.href ? 'grey.700' : 'grey.400'}
                  />
                </LinkButton>
              ))}
            </Stack>
          </Stack>
        </Stack>

        <Button
          variant="outlined"
          size="xsmall"
          href={isPeople ? peoplePageLink : companyPageLink}
          target="_blank"
        >
          View Profile
        </Button>
      </Styled.Wrapper>
    );
  }
);

DetailHeader.displayName = 'DetailHeader';
